"use client";

import Link from "next/link";

import { motion } from "framer-motion";
import { ArrowLeftIcon } from "@phosphor-icons/react";

export default function NotFound() {
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-gradient-to-br from-white via-gray-50 to-gray-100 px-4">
      {/* 🔮 Background Glow */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-[-100px] left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-black/5 blur-3xl rounded-full" />
      </div>

      <div className="max-w-xl w-full text-center">
        {/* 🚀 Animated 404 */}
        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-[80px] sm:text-[120px] font-extrabold tracking-tight text-gray-900"
        >
          404
        </motion.h1>

        {/* ✨ Title */}
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="text-xl sm:text-2xl font-semibold text-gray-800"
        >
          Page not found
        </motion.h2>

        {/* 📄 Description */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
          className="mt-3 text-gray-500 text-sm sm:text-base"
        >
          The page you’re looking for doesn’t exist or has been moved. Let’s get
          you back on track.
        </motion.p>

        {/* 🔘 Actions */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3"
        >
          <Link
            href="/"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-black text-white text-sm font-medium hover:opacity-90 transition"
          >
            <ArrowLeftIcon size={16} />
            Back to Home
          </Link>

          <Link
            href="/dashboard"
            className="px-5 py-2.5 rounded-xl border text-sm font-medium hover:bg-gray-100 transition"
          >
            Go to Dashboard
          </Link>
        </motion.div>
      </div>
    </div>
  );
}
